import React, { useState } from "react";

import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";
import RegistHeader from "./RegistHeader";

import { postResendVerificationCode } from "../../services/api/user/postResendVerificationCode";

import styles from "./p-register.module.scss";
import formStyles from "../../common/forms/g-formInput.module.scss";
import { ValType } from "../../utils/ValidationFunctions";
import { useNavigate } from "react-router";

const ResendVerificationCodeContainer: React.FC = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const handleEmail = (value: string) => {
    setEmail(value);
  };

  const handleSubmit = async () => {
    if (email) {
      await postResendVerificationCode(email);
      navigate(`/verify?email=${email}`);
    }
  };

  return (
    <ResendVerificationCode
      submit_handler={handleSubmit}
      email_handler={handleEmail}
    />
  );
};

export default ResendVerificationCodeContainer;

type Props = {
  submit_handler: () => void;
  email_handler: (value: string) => void;
};
export const ResendVerificationCode: React.FC<Props> = ({
  submit_handler,
  email_handler,
}) => {
  return (
    <div className={styles["p-register__container"]}>
      <div className={styles["p-register__box"]}>
        <RegistHeader
          showLogo={false}
          title={"認証コード再送信"}
          message={"認証コードを送るメールアドレスを入力してください"}
        />
        <div className={styles["p-register__form"]}>
          <Form
            handler={submit_handler}
            button_id="next_button"
            button_text="再送信"
            button_class={formStyles["g-button"]}
          >
            <div className={formStyles["g-form__wrapper"]}>
              <FormInput
                type="textBeforeLabel"
                label="メールアドレス"
                name="sonic_email"
                val_type={ValType.NotNull}
                placeholder="guile@gmail.com"
                id="sonic_email"
                handler={email_handler}
                style_class={formStyles["g-form__input"]}
                label_class={formStyles["g-form__label"]}
              />
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
